import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useGoogleAccessToken = () => {
  const {
    data: token,
    isLoading,
    error,
    refetch,
  } = useQuery<string>({
    queryKey: ["google-access-token"],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke("cloud-storage", {
        body: {
          action: "get-access-token",
          data: { provider: "google_drive" },
        },
      });

      if (error || !data?.accessToken) {
        throw new Error(error?.message || "Failed to get access token");
      }

      return data.accessToken;
    },
    enabled: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return { token: token || "", isLoading, error, refetch };
};
